<template>
    <div>
        <div class="item-box">
            <div class="item-box-top">
                <div class="item-box-top-t">
                    <div class="item-box-top-t-l">
                        <div class="item-box-top-t-l-s">
                            <div class="user-name">
                                <img
                                    style="width: 24px;border-radius:3px;"
                                    :src="itemData.fillingType == 1 ? itemData.avatar : (itemData.fillingType == 3 ? itemData.avatar : itemData.lsSybCreateLinks.writeHeadPortrait)"
                                    alt=""
                                />
                                <div style="max-width: 170px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;">
                                    {{ itemData.name }}/{{
                                        itemData.fillingType == 1 ? itemData.refereesName : (itemData.fillingType == 3 ? itemData.refereesName : itemData.lsSybCreateLinks.staffName)
                                    }}的{{
                                        itemData.fillingType == 1 ? itemData.doctorRelationship : (itemData.fillingType == 3 ? itemData.doctorRelationship : (itemData.lsSybCreateLinks.customerType == '普通客户' ? '普通客户' : (itemData.lsSybCreateLinks.customerType == '重要客户' ? '重要客户' : (itemData.lsSybCreateLinks.customerType.length > 2 ? itemData.lsSybCreateLinks.customerType.substring(3,itemData.lsSybCreateLinks.customerType.length) : '其他客户'))))
                                    }}
                                    
                                </div>
                                <slot name="editname"></slot>
                            </div>
                        </div>
                        <div class="item-box-top-t-l-s">
                            <slot name="gzxqdslot"></slot>
                        </div>
                    </div>
                    <div class="content-box">
                        <slot name="content"></slot>
                    </div>
                </div>
            </div>
            <div style="margin-top: 10px;">
                <slot name="bottomcontent"></slot>
            </div>
            
            <!-- <div class="item-box-bottom">
                <div>
                    <slot name="leftbtn"></slot>
                </div>
                <div class="btm-right-box">
                    <slot name="rightbtn"></slot>
                </div>
            </div> -->
            <div></div>
        </div>
    </div>
</template>
<script>
export default {
    props: {
        itemData: Object,
    },
    data() {
        return {};
    },
    filters: {
        gxFilter(value) {
            switch (value) {
                case "1":
                    return "父母";
                case "2":
                    return "兄弟";
                case "3":
                    return "朋友";
                case "4":
                    return "同事";
                case "5":
                    return "亲戚";
                default:
                    return "未知";
            }
        },
    },
    mounted() {},
    methods: {},
};
</script>
<style scoped>
.item-box {
    width: 94%;
    margin-left: 3%;
    background: #fff;
    border-radius: 5px;
    box-shadow: 0px 1px 3px 0px rgba(30, 74, 149, 0.1);
}
.item-box-bottom {
    width: 94%;
    margin-left: 3%;
    border-top: 1px solid #f2f2f2;
    margin-top: 10px;
    height: 46px;
    display: flex;
    align-items: center;
    justify-content: space-between;
}
.item-box-top-t-l {
    display: flex;
    align-items: center;
    justify-content: space-between;
    /* margin: 15px 0; */
}
.item-box-top-t-l-s {
    display: flex;
    align-items: center;
    /* justify-content: space-between; */
    /* margin: 15px 0; */
}
.user-name {
    display: flex;
    align-items: center;
}
.user-name img {
    margin-right: 8px;
}
.item-box-top-t {
    padding: 15px 10px 0 10px;
}
.content-box {
    margin-top: 15px;
    line-height: 27px;;
}
.btm-right-box {
    width: 90%;
    display: flex;
    align-items: center;
}
.right-arrow {
    width: 7px;
    height: 7px;
    border-top: 1px solid #c0c0c0;
    border-right: 1px solid #c0c0c0;
    transform: rotate(45deg);
}
</style>
